<template>
  <div>
    <vs-table :data="history.items" max-items="10" pagination class="mass-history-card">
      <template slot="thead">
        <vs-th>Lote</vs-th>
        <vs-th>Nome</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Resumo</vs-th>
        <vs-th>Criado por</vs-th>
        <vs-th>Criado em</vs-th>
        <vs-th>Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :key="row.id" v-for="row in data">
            <vs-td>#{{ row.id }}</vs-td>
            <vs-td>{{ row.name }}</vs-td>
            <vs-td>
              <vs-chip :color="statusColor(row.status)">{{ row.status }}</vs-chip>
            </vs-td>
            <vs-td>
              <span class="text-small">total: {{ row.total_tenants }} | ok: {{ row.success_tenants }} | falhas: {{ row.failed_tenants }}</span>
            </vs-td>
            <vs-td>{{ row.requester_name || '-' }}</vs-td>
            <vs-td>{{ row.created_at || '-' }}</vs-td>
            <vs-td>
              <vs-button
                size="small"
                color="primary"
                type="border"
                icon-pack="feather"
                :icon="isDetailOpen(row.id) ? 'icon-chevron-up' : 'icon-eye'"
                :title="isDetailOpen(row.id) ? 'Fechar detalhe' : 'Abrir detalhe'"
                @click="$emit('show-batch-detail', row.id)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div class="mt-4 batch-detail-panel" v-if="selectedBatchDetail" >
      <div class="batch-detail-header">
        <div class="batch-detail-title-wrap">
          <h4 class="mb-1 batch-detail-title">Detalhes do Lote #{{ selectedBatchDetail.id }}</h4>
          <p class="mb-0 batch-detail-subtitle">
            Itens: {{ (selectedBatchDetail.items || []).length }} | Criado em: {{ selectedBatchDetail.created_at || '-' }}
          </p>
        </div>
        <vs-chip :color="statusColor(selectedBatchDetail.status)">{{ selectedBatchDetail.status || '-' }}</vs-chip>
      </div>

      <vs-table :data="batchDetailItems" max-items="10" pagination>
        <template slot="thead">
          <vs-th>Tenant</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Campanha Criada</vs-th>
          <vs-th>Tentativas</vs-th>
          <vs-th>Erro</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :key="row.id" v-for="row in data">
              <vs-td>{{ row.tenant_name }}</vs-td>
              <vs-td><vs-chip :color="statusColor(row.status)">{{ row.status }}</vs-chip></vs-td>
              <vs-td>{{ row.created_campaign_id || '-' }}</vs-td>
              <vs-td>{{ row.attempts || 0 }}</vs-td>
              <vs-td>
                <div class="batch-error-cell" v-if="row._errorInfo && row._errorInfo.hasError">
                  <div class="batch-error-line">
                    <vs-button
                      size="small"
                      color="danger"
                      type="border"
                      icon-pack="feather"
                      :icon="isErrorDetailOpen(row) ? 'icon-chevron-up' : 'icon-eye'"
                      :title="isErrorDetailOpen(row) ? 'Ocultar detalhe' : 'Ver detalhe'"
                      class="batch-error-toggle"
                      v-if="row._errorInfo.detail"
                      @click="toggleErrorDetail(row)"
                    />
                    <p class="mb-0 batch-error-summary text-danger">{{ row._errorInfo.summary }}</p>
                  </div>
                  <pre class="batch-error-detail mt-2" v-if="row._errorInfo.detail && isErrorDetailOpen(row)">{{ row._errorInfo.detail }}</pre>
                </div>
                <span v-else>-</span>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import { massCampaignStatusColor, parseMassCampaignError } from '@/utils';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: 'MassCampaignHistorySection',
  components: {
    flatPickr,
  },
  props: {
    history: {
      type: Object,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    historyStatusOptions: {
      type: Array,
      required: true,
    },
    selectedBatchDetail: {
      type: Object,
      default: null,
    },
    datePickerConfig: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expandedErrorRows: {},
    };
  },
  computed: {
    batchDetailItems() {
      const items = this.selectedBatchDetail && Array.isArray(this.selectedBatchDetail.items)
        ? this.selectedBatchDetail.items
        : [];

      return items.map((item, index) => {
        const row = Object.assign({}, item || {});
        const rowId = row.id === null || row.id === undefined
          ? `${row.tenant_name || 'tenant'}-${index}`
          : `${row.id}`;

        row._errorRowKey = `${rowId}-${index}`;
        row._errorInfo = parseMassCampaignError(row.error_message);
        return row;
      });
    },
  },
  methods: {
    statusColor: massCampaignStatusColor,
    isDetailOpen(batchId) {
      const selectedId = Number(this.selectedBatchDetail && this.selectedBatchDetail.id);
      const rowId = Number(batchId);
      return !Number.isNaN(selectedId) && !Number.isNaN(rowId) && selectedId === rowId;
    },
    isErrorDetailOpen(row) {
      const rowKey = row && row._errorRowKey ? row._errorRowKey : null;
      if (!rowKey) {
        return false;
      }

      return !!this.expandedErrorRows[rowKey];
    },
    toggleErrorDetail(row) {
      const rowKey = row && row._errorRowKey ? row._errorRowKey : null;
      if (!rowKey) {
        return;
      }

      this.$set(this.expandedErrorRows, rowKey, !this.expandedErrorRows[rowKey]);
    }
  },
  watch: {
    selectedBatchDetail() {
      this.expandedErrorRows = {};
    },
  }
};
</script>

<style lang="scss">
.vs-con-table {
  .vs-con-tbody {
    background: #f8f8f8;
    border: 2px solid #f8f8f8;
  }

  .vs-table--header {
    display: flex;
    flex-wrap: wrap-reverse;
    margin-left: 1.5rem;
    margin-right: 1.5rem;

    > span {
      display: flex;
      flex-grow: 1;
    }

    .vs-table--search {
      padding-top: 0;

      .vs-table--search-input {
        padding: 0.9rem 2.5rem;
        font-size: 1rem;

        & + i {
          left: 1rem;
        }

        &:focus + i {
          left: 1rem;
        }
      }
    }
  }

  .vs-table {
    border-collapse: separate;
    border-spacing: 0 1.3rem;
    padding: 0 1rem;

    tr {
      box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

      td {
        padding: 10px;
        text-align: center;

        &:first-child {
          border-top-left-radius: .5rem;
          border-bottom-left-radius: .5rem;
        }

        &:last-child {
          border-top-right-radius: .5rem;
          border-bottom-right-radius: .5rem;
        }
      }

      td.td-check {
        padding: 20px !important;
      }

      td.td.vs-table--td.actionTD > span {
        display: flex;
        justify-content: center;
      }
    }
  }

  .vs-table--thead {
    th {
      padding-top: 0;
      padding-bottom: 0;

      .vs-table-text {
        text-transform: uppercase;
        font-weight: 600;
        justify-content: center !important;
      }
    }

    th.td-check {
      padding: 0 15px !important;
    }

    tr {
      background: none;
      box-shadow: none;
    }
  }

  .vs-table--pagination {
    justify-content: center;
  }
}
</style>

<style lang="scss" scoped>
.input-label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
}

.batch-detail-panel {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 12px;
  background: #ffffff;
}

.batch-detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eef2f7;
  margin-bottom: 12px;
}

.batch-detail-title-wrap {
  min-width: 0;
}

.batch-detail-title {
  font-size: 18px;
  font-weight: 600;
  color: #2f3b52;
}

.batch-detail-subtitle {
  font-size: 12px;
  color: #7c8798;
}

.batch-error-cell {
  display: block;
  max-width: 100%;
}

.batch-error-line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.batch-error-summary {
  margin: 0;
  white-space: normal;
  word-break: break-word;
  line-height: 1.45;
  flex: 1;
}

.batch-error-toggle {
  min-height: 28px;
}

.batch-error-detail {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 11px;
  line-height: 1.45;
  color: #334155;
  border: 1px solid #fee2e2;
  border-radius: 6px;
  background: #fff7f7;
  padding: 8px;
}
</style>
